import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Feature } from '@assetaccountant/api/models/feature';
import { OrganisationPermissionType } from '@assetaccountant/api/models/organisation-permission-type';
import { getFeatureDisplay } from '@assetaccountant/core/models/enum/feature-display';
import { SubscriptionService } from '@assetaccountant/core/services/subscription.service';
import { TypedNgbModal, setupModal } from '@assetaccountant/core/utils/typed-modal';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { ViewPricingModalComponent } from '../navigation/view-pricing-modal/view-pricing-modal.component';

@Component({
  selector: 'app-feature-limit-modal',
  templateUrl: './feature-limit-modal.component.html',
  styleUrls: ['./feature-limit-modal.component.scss'],
  standalone: false,
})
export class FeatureLimitModalComponent {
  @Input() features: Feature[] = [];

  readonly OrganisationPermissionType = OrganisationPermissionType;

  canUpgradeFromApp$ = this.subscriptionService.subscription.pipe(
    map(sub => {
      return (
        sub.canChangePackageFromApp &&
        this.subscriptionService.areFeaturesAvailableInPlans(this.features)
      );
    }),
  );

  get featureDisplay() {
    return this.features.map(getFeatureDisplay);
  }

  constructor(
    public modal: NgbActiveModal,
    private subscriptionService: SubscriptionService,
    @Inject(NgbModal) public ngbModal: TypedNgbModal,
    private router: Router,
  ) {}

  close() {
    this.modal.close();
  }

  upgrade() {
    setupModal(
      this.ngbModal.open(ViewPricingModalComponent, { size: 'xl' }),
      modal => {
        modal.destinationRouteCommand = this.router.url;
      },
      modal => modal.packageUpdated.subscribe(() => this.close()),
    );
  }
}
